export default {
	API_URL: "https://cron-manager-back.portail-defi.net/",
	color: '#96a6ff',
	colorTwo: '#b0bdfc',
	backgroundColorOne: 'rgba(111, 132, 226, 0.7)', 
	backgroundColorTwo: 'rgba(20, 20, 20, 0.7)', 
}
